module.exports = __webpack_public_path__ + "fullstory.c9cb6b.svg";